export const webcamImage = async (err) => {
  if (err) {
    console.error(err);
  }

  document.addEventListener('DOMContentLoaded', () => {
    updateImg();
  });

  function updateImg() {
    if (document.getElementById('cam')) {
      var source =
          'https://www.pradaschier.ch/webcam/webcam-pradaschier-gross.jpg',
        timestamp = new Date().getTime(),
        newUrl = source + '?_=' + timestamp;
      document.getElementById('cam').src = newUrl;
      // reset status bar if new image is inserted
      const webcamStatusBar = document.getElementsByClassName(
        'webcam-image-statusbar',
      )[0];
      var newone = webcamStatusBar.cloneNode(true);
      webcamStatusBar.parentNode.replaceChild(newone, webcamStatusBar);
    }
  }
  // Update the image every 10 seconds

  window.setInterval(function () {
    updateImg();
  }, 30000);
};

import.meta.webpackHot?.accept(webcamImage);
